<table class="table table-fixed table-hover mb-0 table_hoizental self_assesmentT3_table">
  <thead>
    <tr>
      <th class="text-center width-1pr">
        <input type="checkbox" [checked]="selectedItems.length > 0 ? 'checked' : ''"
          (change)="allSelectedItems($event,this.selfAssessmentList)" />
      </th>
      <th *ngIf="selfAssessmentT3ColumnModel.id" class="width-3pr text-center"
        (click)="sortSelfAssessment('RulebookRuleID')">
        Id
        <i class="fa"
          [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT3Filter.sortKey === 'rulebookRuleID' && !selfAssessmentT3Filter.isDesc),
          'fa-sort-amount-desc': (selfAssessmentT3Filter.sortKey === 'RulebookRuleID' && selfAssessmentT3Filter.isDesc) }"
          aria-hidden="true">
        </i>
      </th>
      <th *ngIf="selfAssessmentT3ColumnModel.Rulebook" class="width-6pr text-center"
        (click)="sortSelfAssessment('ruleBook')">Rulebook
        <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT3Filter.sortKey === 'ruleBook' && !selfAssessmentT3Filter.isDesc),
          'fa-sort-amount-desc': (selfAssessmentT3Filter.sortKey === 'ruleBook' && selfAssessmentT3Filter.isDesc) }"
          aria-hidden="true">
        </i>
      </th>
      <th *ngIf="selfAssessmentT3ColumnModel.part" class="width-6pr text-center" (click)="sortSelfAssessment('Part')">
        Part
        <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT3Filter.sortKey === 'Part' && !selfAssessmentT3Filter.isDesc),
          'fa-sort-amount-desc': (selfAssessmentT3Filter.sortKey === 'Part' && selfAssessmentT3Filter.isDesc) }"
          aria-hidden="true">
        </i>
      </th>
      <th *ngIf="selfAssessmentT3ColumnModel.ruleId" class="width-6pr text-center"
        (click)="sortSelfAssessment('RuleID')">Rule Id
        <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT3Filter.sortKey === 'RuleID' && !selfAssessmentT3Filter.isDesc),
          'fa-sort-amount-desc': (selfAssessmentT3Filter.sortKey === 'RuleID' && selfAssessmentT3Filter.isDesc) }"
          aria-hidden="true">
        </i>
      </th>
      <th *ngIf="selfAssessmentT3ColumnModel.ruleOwner" class="width-6pr text-center"
        (click)="sortSelfAssessment('Owner')">Rule Owner
        <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT3Filter.sortKey === 'Owner' && !selfAssessmentT3Filter.isDesc),
          'fa-sort-amount-desc': (selfAssessmentT3Filter.sortKey === 'Owner' && selfAssessmentT3Filter.isDesc) }"
          aria-hidden="true">
        </i>
      </th>
      <th *ngIf="selfAssessmentT3ColumnModel.complianceStatus" class="width-6pr text-center"
        (click)="sortSelfAssessment('ComplianceStatus')">Compliance Status
        <i class="fa"
          [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT3Filter.sortKey === 'ComplianceStatus' && !selfAssessmentT3Filter.isDesc),
          'fa-sort-amount-desc': (selfAssessmentT3Filter.sortKey === 'ComplianceStatus' && selfAssessmentT3Filter.isDesc) }"
          aria-hidden="true">
        </i>
      </th>
      <th *ngIf="selfAssessmentT3ColumnModel.assessmentStatus" class="width-6pr text-center"
        (click)="sortSelfAssessment('AssessmentStatus')">Assessment Status
        <i class="fa"
          [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT3Filter.sortKey === 'AssessmentStatus' && !selfAssessmentT3Filter.isDesc),
          'fa-sort-amount-desc': (selfAssessmentT3Filter.sortKey === 'AssessmentStatus' && selfAssessmentT3Filter.isDesc) }"
          aria-hidden="true">
        </i>
      </th>
      <th *ngIf="selfAssessmentT3ColumnModel.reviewDate" class="width-6pr text-center"
        (click)="sortSelfAssessment('ReviewDate')">Review Date
        <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT3Filter.sortKey === 'ReviewDate' && !selfAssessmentT3Filter.isDesc),
          'fa-sort-amount-desc': (selfAssessmentT3Filter.sortKey === 'ReviewDate' && selfAssessmentT3Filter.isDesc) }"
          aria-hidden="true">
        </i>
      </th>
      <th *ngIf="selfAssessmentT3ColumnModel.assessmentDate" class="width-6pr text-center"
        (click)="sortSelfAssessment('AssessmentDate')">Assessment Date
        <i class="fa"
          [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT3Filter.sortKey === 'AssessmentDate' && !selfAssessmentT3Filter.isDesc),
          'fa-sort-amount-desc': (selfAssessmentT3Filter.sortKey === 'AssessmentDate' && selfAssessmentT3Filter.isDesc) }"
          aria-hidden="true">
        </i>
      </th>
      <th *ngIf="selfAssessmentT3ColumnModel.lbgImpact" class="width-6pr text-center"
        (click)="sortSelfAssessment('LBGImpact')">LBG Impact
        <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT3Filter.sortKey === 'LBGImpact' && !selfAssessmentT3Filter.isDesc),
          'fa-sort-amount-desc': (selfAssessmentT3Filter.sortKey === 'LBGImpact' && selfAssessmentT3Filter.isDesc) }"
          aria-hidden="true">
        </i>
      </th>
      <th *ngIf="selfAssessmentT3ColumnModel.rfbImpact" class="width-6pr text-center"
        (click)="sortSelfAssessment('RFBImpact')">RFB Impact
        <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT3Filter.sortKey === 'RFBImpact' && !selfAssessmentT3Filter.isDesc),
          'fa-sort-amount-desc': (selfAssessmentT3Filter.sortKey === 'RFBImpact' && selfAssessmentT3Filter.isDesc) }"
          aria-hidden="true">
        </i>
      </th>
      <th *ngIf="selfAssessmentT3ColumnModel.lbcmImpact" class="width-6pr text-center"
        (click)="sortSelfAssessment('LBCMImpact')">LBCM Impact
        <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT3Filter.sortKey === 'LBCMImpact' && !selfAssessmentT3Filter.isDesc),
          'fa-sort-amount-desc': (selfAssessmentT3Filter.sortKey === 'LBCMImpact' && selfAssessmentT3Filter.isDesc) }"
          aria-hidden="true">
        </i>
      </th>
      <th *ngIf="selfAssessmentT3ColumnModel.nextAssessmentDueDate" class="width-8pr text-center"
        (click)="sortSelfAssessment('NextAssessmentDueDate')">Next Assessment Due Date
        <i class="fa"
          [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT3Filter.sortKey === 'NextAssessmentDueDate' && !selfAssessmentT3Filter.isDesc),
          'fa-sort-amount-desc': (selfAssessmentT3Filter.sortKey === 'NextAssessmentDueDate' && selfAssessmentT3Filter.isDesc) }"
          aria-hidden="true">
        </i>
      </th>
      <th class="width-6pr text-center">Action</th>
    </tr>
  </thead>
  <tbody *ngIf="selfAssessmentList.length === 0">
    <tr>
      <td>No Data</td>
    </tr>
  </tbody>
  <tbody *ngIf="(selfAssessmentList && (selfAssessmentList.length > 0))" [style.max-height.px]="myInnerHeight">
    <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="35" (scrolledIndexChange)="handler($event)"
      [style.height.px]="myInnerHeight" *ngIf="selfAssessmentList.length > 0">
      <div *cdkVirtualFor="let item of selfAssessmentList; let i = index">
        <tr (click)="selectedItemId = item.id" (dblclick)="redirectLink(item.id)">
          <td class="width-1pr text-center " scope="row">
            <input type="checkbox"
              [checked]="_globalService.getSelectedItems(item.id, this.selectedItems) ? 'checked' : ''"
              (change)="selectItem($event, item.id)" />
          </td>
          <td *ngIf="selfAssessmentT3ColumnModel.id" class="width-3pr text-center tabel-td-scroll " scope="row">
            <a (click)="redirectLink(item.id)">
              <p class="mb-0" *ngFor="let rId of item.rulebookRuleID.split('|')">{{rId}}</p>
            </a>
          </td>
          <td *ngIf="selfAssessmentT3ColumnModel.Rulebook" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.ruleBook}}</td>
          <td *ngIf="selfAssessmentT3ColumnModel.part" class="width-6pr text-center tabel-td-scroll" scope="row">
            {{item.part}}</td>
          <td *ngIf="selfAssessmentT3ColumnModel.ruleId" class="width-6pr text-center tabel-td-scroll" scope="row">
            {{item.ruleID}}</td>
          <td *ngIf="selfAssessmentT3ColumnModel.ruleOwner" class="width-6pr text-center tabel-td-scroll" scope="row">
            {{item.owner}}</td>
          <td *ngIf="selfAssessmentT3ColumnModel.complianceStatus" class="width-6pr text-center tabel-td-scroll"
            scope="row">{{item.complianceStatus}}</td>
          <td *ngIf="selfAssessmentT3ColumnModel.assessmentStatus" class="width-6pr text-center tabel-td-scroll"
            scope="row">{{item.assessmentStatus}}</td>
          <td *ngIf="selfAssessmentT3ColumnModel.reviewDate" class="width-6pr text-center tabel-td-scroll" scope="row">
            {{item.reviewDate | date:'dd-MMM-yyyy'}}</td>
          <td *ngIf="selfAssessmentT3ColumnModel.assessmentDate" class="width-6pr text-center tabel-td-scroll"
            scope="row">{{item.assessmentDate | date:'dd-MMM-yyyy'}}
          </td>
          <td *ngIf="selfAssessmentT3ColumnModel.lbgImpact" class="width-6pr text-center tabel-td-scroll" scope="row">
            {{item.lbgImpact ? 'Yes' : 'No'}}</td>
          <td *ngIf="selfAssessmentT3ColumnModel.rfbImpact" class="width-6pr text-center tabel-td-scroll" scope="row">
            {{item.rfbImpact ? 'Yes' : 'No'}}</td>
          <td *ngIf="selfAssessmentT3ColumnModel.lbcmImpact" class="width-6pr text-center tabel-td-scroll" scope="row">
            {{item.lbcmImpact ? 'Yes' : 'No'}} </td>
          <td *ngIf="selfAssessmentT3ColumnModel.nextAssessmentDueDate" class="width-8pr text-center tabel-td-scroll"
            scope="row">{{item.nextAssessmentDueDate |
            date:'dd-MMM-yyyy'}}</td>
          <td class="width-6pr text-center tabel-td-scroll"><a
              href="/self-assessment/details/self/3/{{item.id}}">View</a> |
            <span>
              <a>Copy</a>
            </span>
          </td>
        </tr>
      </div>
    </cdk-virtual-scroll-viewport>
  </tbody>
</table>
